export default "__VITE_ASSET__CsUFHzPB__"